'use client';

import * as Popover from '@radix-ui/react-popover';
import { useState } from 'react';
import { Marker as MapMarker, useMap } from 'react-map-gl/maplibre';

import * as StoreCard from '@/components/Store/StoreCard';

import { MarkerIcon } from './MarkerIcon';

export type StoreMarkerProps = {
  store: AdaptedStore | AdaptedStore<true>;
  openPreviewOnClick?: boolean;
};

export function StoreMarker({
  store,
  openPreviewOnClick = true,
}: StoreMarkerProps) {
  const [isOpen, setIsOpen] = useState(false);

  const mapRef = useMap();

  function onMarkerClick(open: boolean) {
    if (!openPreviewOnClick) return;

    setIsOpen(open);
  }

  if (!store.address.geometry) return null;

  return (
    <Popover.Root open={isOpen} onOpenChange={onMarkerClick}>
      <MapMarker
        latitude={store.address.geometry?.lat}
        longitude={store.address.geometry?.lon}
      >
        <Popover.Trigger className="cursor-pointer">
          <MarkerIcon isSelected={isOpen} />
        </Popover.Trigger>
      </MapMarker>

      <Popover.Portal forceMount container={mapRef.current?.getContainer()}>
        <Popover.Content className="hidden scale-95 opacity-0 transition-opacity data-[state=open]:block data-[state=open]:scale-100 data-[state=open]:opacity-100">
          <Popover.Arrow className="fill-white" width={35} height={12} />

          <StoreCard.Root
            store={store}
            className="max-w-40 gap-2 p-2 md:max-w-60 lg:gap-2"
          >
            <StoreCard.TitleImage className="-mt-5" />

            <StoreCard.Content>
              <StoreCard.Info>
                <StoreCard.Name className="sm:text-base" />

                <StoreCard.Street className="sm:text-sm" />
              </StoreCard.Info>

              <StoreCard.CategoryIcon />
            </StoreCard.Content>
          </StoreCard.Root>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
